import CustomNotification from "./CustomNotification";

export default CustomNotification;
